import React from "react";
import {useState,useEffect} from "react";
import {useLocation,useNavigate} from "react-router-dom";
import Grid from "@mui/material/Grid";
import LinearProgress from "@mui/material/LinearProgress";
import {Box} from "@mui/system";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {Dialog} from "primereact/dialog";
import {confirmDialog} from "primereact/confirmdialog";
import {ConfirmDialog} from "primereact/confirmdialog";
import {BlockUI} from "primereact/blockui";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Dropdown} from "primereact/dropdown";
import {InputTextarea} from 'primereact/inputtextarea';
import {Tag} from "primereact/tag";
import {MultiSelect} from "primereact/multiselect";
import Message from "../Helpers/Message.js";
import {fetch_url_post,focus_next} from "../../Sources/js/app.js";

let oper="";

let currentDate=new Date();
let currentYear=currentDate.getFullYear();
let currentMonth=currentDate.getMonth()+1;
let yearsList=[];
let monthsList=[
	{
		label: "IANUARIE",
		value: 1,
	},
	{
		label: "FEBRUARIE",
		value: 2,
	},
	{
		label: "MARTIE",
		value: 3,
	},
	{
		label: "APRILIE",
		value: 4,
	},
	{
		label: "MAI",
		value: 5,
	},
	{
		label: "IUNIE",
		value: 6,
	},
	{
		label: "IULIE",
		value: 7,
	},
	{
		label: "AUGUST",
		value: 8,
	},
	{
		label: "SEPTEMBRIE",
		value: 9,
	},
	{
		label: "OCTOMBRIE",
		value: 10,
	},
	{
		label: "NOIEMBRIE",
		value: 11,
	},
	{
		label: "DECEMBRIE",
		value: 12,
	},
];

for(let i=-2;i<2;i++) {
	let cYear={
		label: currentYear+i,
		value: currentYear+i
	}
	yearsList.push(cYear);
} 

let defaultInputValues={
	id: null,
	center_id: 0,
	type_id: 0,
	year: currentYear,
	month: currentMonth,
	observations: "",
	filter_centers: "",
	filter_years: currentYear,
	filter_months: [currentMonth],
	filter_types: "",
	active: 1,
};

let defaultInputValuesProducts={
	id: null,
	product_id: 0,
	product_mu_id: "",
	filter_products: "",
	product_type_id: 0,
	filter_product_type: "",
	observations: "",
	sub_agreements_id: 0,
	filter_invalid: 0,
};

let defaultInputValuesTemplates={
	id: null,
	name: "",
	observations: "",
	filter_templates: "",
};

let defaultDataValues={
	centersRequestsList: [],
	productsList: [],
	MUsList:[],
	centersList: [],
	requestProductsList: [],
	productsTypesList: [],
	templatesList: [],
	subAgreementsList: [],
};

let defaultDialogValues={
	openAddEdit: false,
	titleAddEdit: "",
	openAddEditProduct: false,
	titleAddEditProduct: "",
	openListProducts: false,
	titleListProducts: "",
	openListTemplates: false,
	titleListTemplates: "",
};

let defaultInputError={
	disableSave: false,
	errorText: "",
};

let activeList=[
	{label: "DA",value: 1},
	{label: "NU",value: 0},
];

let currentRequest={};

const MonthlyRequests = (props) => {

	var timerId=null;
	defaultInputValues.id=(props.providerId?props.providerId:null);
	let ct=1;

	const [inputValues, setInputValues] = useState(defaultInputValues);
	const [dataValues, setDataValues] = useState(defaultDataValues);
	const [messageText, setMessageText] = useState(null);
	const [dataOk, setDataOk] = useState(false);
	const [dialogValues, setDialogValues] = useState(defaultDialogValues);
	const [inputError, setInputError] = useState(defaultInputError);	
	const [blockScreen, setBlockScreen] = useState(false);
	const [centersRequestsList, setCentersRequestsList] = useState([]);
	const [inputValuesProducts, setInputValuesProducts] = useState(defaultInputValuesProducts);
	const [requestProductsList, setRequestProductsList] = useState([]);
	const [productsList, setProductsList] = useState([]);
	const [inputValuesTemplates, setInputValuesTemplates] = useState(defaultInputValuesTemplates);
	const [templatesList, setTemplatesList] = useState([]);
	const [tableQuantities, setTableQuantities] = useState([]);
	const [unitaryPrice, setUnitaryPrice] = useState("");
	const [availableQuantity, setAvailableQuantity] = useState("");
    const location = useLocation();
    const navigate = useNavigate();

	const handleChange = evt => {
		const {name, value} = evt.target;
		if(name==="center_id") {
			let found=false;
			if(dataValues.centersRequestsList.length>0) {
				dataValues.centersRequestsList.forEach(element => {
					if((value===element.center_id)&&(inputValues.year===element.year)&&(inputValues.month===element.month)&&(inputValues.type_id===element.type_id)) {
						found=true;
					}
				});
			}
			let tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja un necesar pentru centrul,tipul si luna selectata!":""),
			}
			setInputError(tmp);
		}
		if(name==="year") {
			let found=false;
			if(dataValues.centersRequestsList.length>0) {
				dataValues.centersRequestsList.forEach(element => {
					if((value===element.year)&&(inputValues.center_id===element.center_id)&&(inputValues.month===element.month)&&(inputValues.type_id===element.type_id)) {
						found=true;
					}
				});
			}
			let tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja un necesar pentru centrul,tipul si luna selectata!":""),
			}
			setInputError(tmp);
		}
		if(name==="month") {
			let found=false;
			if(dataValues.centersRequestsList.length>0) {
				dataValues.centersRequestsList.forEach(element => {
					if((value===element.month)&&(inputValues.year===element.year)&&(inputValues.center_id===element.center_id)&&(inputValues.type_id===element.type_id)) {
						found=true;
					}
				});
			}
			let tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja un necesar pentru centrul,tipul si luna selectata!":""),
			}
			setInputError(tmp);
		}
		if(name==="type_id") {
			let found=false;
			if(dataValues.centersRequestsList.length>0) {
				dataValues.centersRequestsList.forEach(element => {
					if((value===element.type_id)&&(inputValues.year===element.year)&&(inputValues.month===element.month)&&(inputValues.center_id===element.center_id_id)) {
						found=true;
					}
				});
			}
			let tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja un necesar pentru centrul,tipul si luna selectata!":""),
			}
			setInputError(tmp);
		}
		if(name==="filter_centers") {
			setCentersRequestsList(dataValues.centersRequestsList
																.filter((request)=>((request.center_name.toLowerCase().indexOf(value.toLowerCase())>-1)||(value==="")))
																.filter((request)=>((request.year===inputValues.filter_years)||(inputValues.filter_years==="")))
																.filter((request)=>(inputValues.filter_months.includes(request.month)))
																.filter((request)=>((request.type_id===inputValues.filter_types)||(inputValues.filter_types==="")||(!inputValues.filter_types)))
			);
		}
		if(name==="filter_years") {
			setCentersRequestsList(dataValues.centersRequestsList
																.filter((request)=>((request.center_name.toLowerCase().indexOf(inputValues.filter_centers.toLowerCase())>-1)||(inputValues.filter_centers==="")))
																.filter((request)=>((request.year===value)||(value==="")))
																.filter((request)=>(inputValues.filter_months.includes(request.month)))
																.filter((request)=>((request.type_id===inputValues.filter_types)||(inputValues.filter_types==="")||(!inputValues.filter_types)))
			);
		}
		if(name==="filter_months") {
			setCentersRequestsList(dataValues.centersRequestsList
																.filter((request)=>((request.center_name.toLowerCase().indexOf(inputValues.filter_centers.toLowerCase())>-1)||(inputValues.filter_centers==="")))
																.filter((request)=>((request.year===inputValues.filter_years)||(inputValues.filter_years==="")))
																.filter((request)=>(value.includes(request.month)))
																.filter((request)=>((request.type_id===inputValues.filter_types)||(inputValues.filter_types==="")||(!inputValues.filter_types)))
			);
		}
		if(name==="filter_types") {
			setCentersRequestsList(dataValues.centersRequestsList
																.filter((request)=>((request.center_name.toLowerCase().indexOf(inputValues.filter_centers.toLowerCase())>-1)||(inputValues.filter_centers==="")))
																.filter((request)=>((request.year===inputValues.filter_years)||(inputValues.filter_years==="")))
																.filter((request)=>(inputValues.filter_months.includes(request.month)))
																.filter((request)=>((request.type_id===value)||(value==="")||(!value)))
			);
		}
		setInputValues({...inputValues,[name]:value});
	}

	const handleChangeProducts = evt => {
		const {name, value} = evt.target;
		let state_update=0;
		if(name==="product_id") {
			let tmp=dataValues.productsList.filter((product)=>(product.id===value));
			if(tmp.length>0) {
				setInputValuesProducts({...inputValuesProducts,product_mu_id:tmp[0].product_mu_id,
																product_type_id: tmp[0].product_type_id,
																product_id:value
				});
				state_update=1;
				let found=false;
				if(dataValues.requestProductsList.length>0) {
					dataValues.requestProductsList.forEach(element => {
						if((value===element.product_id)&&(tmp[0].product_mu_id===element.product_mu_id)) {
							found=true;
						}
					});
				}
				tmp={
					disableSave: found,
					errorText: (found===true?"Exista deja un produs similar adaugat!":""),
				}
				setInputError(tmp);
			}else{
				state_update=true;
				setInputError(defaultInputError);
				setInputValuesProducts(defaultInputValuesProducts);
			}
			setDataValues({...dataValues,subAgreementsList:[]});							
		}
		if(name==="product_mu_id") {
			//reset sub agreement values
			setDataValues({...dataValues,subAgreementsList:[]});										
			setAvailableQuantity("");
			setUnitaryPrice("");
			let found=false;
			if(dataValues.requestProductsList.length>0) {
				dataValues.requestProductsList.forEach(element => {
					if((value===element.product_mu_id)&&(inputValuesProducts.product_id===element.product_id)) {
						found=true;
					}
				});
			}
			let tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja un produs similar adaugat!":""),
			}
			setInputError(tmp);
			state_update=1;
			setInputValuesProducts({...inputValuesProducts,sub_agreements_id:0,[name]:value});
		}
		if(name==="filter_products") {
			setRequestProductsList(dataValues.requestProductsList.filter((product)=>((product.product_name.toLowerCase().indexOf(value.toLowerCase())>-1))||(value===""))
																	.filter((product)=>((product.product_type_id===inputValuesProducts.filter_product_type)||(inputValuesProducts.filter_product_type==="")||(!inputValuesProducts.filter_product_type)))
																	.filter((product)=>(((inputValuesProducts.filter_invalid?product.sub_agreements_id===0:true))))
			);
		}
		if(name==="product_type_id") {
			setProductsList(dataValues.productsList.filter((product)=>((product.product_type_id===value)||(value==="")||(!value))));
		}
		if(name==="filter_product_type") {
			setRequestProductsList(dataValues.requestProductsList.filter((product)=>((product.product_type_id===value)||(value==="")||(!value)))
																	.filter((product)=>((product.product_name.toLowerCase().indexOf(inputValuesProducts.filter_products.toLowerCase())>-1))||(inputValuesProducts.filter_products===""))
																	.filter((product)=>(((inputValuesProducts.filter_invalid?product.sub_agreements_id===0:true))))
			);
		}
		if((name==="unitary_price")||(name==="min_quantity")||(name==="max_quantity")) {
			if(!evt.target.validity.valid) {
				setMessageText("Eroare: Sunt permise numai cifre!");							
				return false;
			}
		}
		if(name==="sub_agreements_id") {
			dataValues.subAgreementsList.forEach(function(agreement) {
				if(agreement.sub_agreement_id===value) {
					setAvailableQuantity(agreement.quantity);
					setUnitaryPrice(agreement.unitary_price);					
				}
			});
		}
		if(name==="filter_invalid") {
			setInputValuesProducts({...inputValuesProducts,[name]:(evt.checked?1:0)});
			setRequestProductsList(dataValues.requestProductsList.filter((product)=>((product.product_name.toLowerCase().indexOf(inputValuesProducts.filter_products.toLowerCase())>-1))||(inputValuesProducts.filter_products===""))
																	.filter((product)=>((product.product_type_id===inputValuesProducts.filter_product_type)||(inputValuesProducts.filter_product_type==="")||(!inputValuesProducts.filter_product_type)))
																	.filter((product)=>(((evt.checked?product.sub_agreements_id===0:true))))
			);
			state_update=1;
		}
		if((name==="quantity_1")||(name==="quantity_2")||(name==="quantity_3")||(name==="quantity_4")) {
			if(!evt.target.validity.valid) {
				setMessageText("Eroare: Sunt permise numai cifre!");							
				return false;
			}			
		}
		if(!state_update) {
			setInputValuesProducts({...inputValuesProducts,[name]:value});
		}
	}

	const handleChangeTemplates = evt => {
		const {name, value} = evt.target;
		if(name==="name") {
			let found=false;
			if(dataValues.templatesList.length>0) {
				dataValues.templatesList.forEach(element => {
					if(value===element.name) {
						found=true;
					}
				});
			}
			let tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja un sablon cu acest nume!":""),
			}
			setInputError(tmp);
		}
		if(name==="filter_templates") {
			setTemplatesList(dataValues.templatesList.filter((template)=>((template.name.toLowerCase().indexOf(value.toLowerCase())>-1))||(value==="")));
		}
		setInputValuesTemplates({...inputValuesTemplates,[name]:value});
	}

	const handleChangeTable = (evt,id,week) => {
		const {name, value} = evt.target;
		if(!evt.target.validity.valid) {
			setMessageText("Eroare: Sunt permise numai cifre!");							
			return false;
		}
		if((name==="quantity_1")||(name==="quantity_2")||(name==="quantity_3")||(name==="quantity_4")) {
			let tmp=[...tableQuantities];
			let index=0;
			tmp.forEach(function(product) {
				if(product.id===id) {
					let c_quantity={};
					if(week===1) {
						c_quantity = {
							id: id,
							quantity_1: value,
							quantity_2: product.quantity_2,
							quantity_3: product.quantity_3,
							quantity_4: product.quantity_4,
						};
					}
					if(week===2) {
						c_quantity = {
							id: id,
							quantity_1: product.quantity_1,
							quantity_2: value,
							quantity_3: product.quantity_3,
							quantity_4: product.quantity_4,
						};
					}
					if(week===3) {
						c_quantity = {
							id: id,
							quantity_1: product.quantity_1,
							quantity_2: product.quantity_2,
							quantity_3: value,
							quantity_4: product.quantity_4,
						};
					}
					if(week===4) {
						c_quantity = {
							id: id,
							quantity_1: product.quantity_1,
							quantity_2: product.quantity_2,
							quantity_3: product.quantity_3,
							quantity_4: value,
						};
					}
					tmp[index]=c_quantity;
				}
				index++;
			});			
			setTableQuantities(tmp);
		}
	}

	const handleFocusTable = (evt) => {
		if(evt.keyCode===13) {
			focus_next(evt);
		}
	}

	const handleButton = (evt,what,elementData) => {
		if(what==="add") {
			setInputValues(defaultInputValues);
			setDialogValues({...dialogValues,openAddEdit: true,titleAddEdit: "Adaugare necesar nou"});
			setInputError(defaultInputError);
		}
		if(what==="edit") {
			elementData.filter_centers=inputValues.filter_centers;
			elementData.filter_years=inputValues.filter_years;
			elementData.filter_months=inputValues.filter_months;
			elementData.filter_types=inputValues.filter_types;
			setInputValues(elementData);
			let tmp=monthsList.filter((month)=>(month.value==elementData.month));
			setDialogValues({...dialogValues,openAddEdit: true,titleAddEdit: "Editare necesar "+elementData.center_name+" pentru "+tmp[0].label});
			setInputError(defaultInputError);
		}
		if(what==="delete") {
			let url="deleteMonthlyRequest";
			url+="?session_id="+props.session.sessId;
			oper="delete";
			let data={
				id: elementData.id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(!inputValues.center_id) {
				setMessageText("Eroare: Alegeti un centru din lista!");				
				document.getElementById("center_id").classList.add("required_input_error");
				return false;
			}
			if(!inputValues.year) {
				setMessageText("Eroare: Alegeti anul!");				
				document.getElementById("year").classList.add("required_input_error");
				return false;
			}
			if(!inputValues.month) {
				setMessageText("Eroare: Alegeti luna!");				
				document.getElementById("month").classList.add("required_input_error");
				return false;
			}
			if(!inputValues.type_id) {
				setMessageText("Eroare: Alegeti tipul!");				
				document.getElementById("type_id").classList.add("required_input_error");
				return false;
			}
			let url="saveMonthlyRequest";
			url+="?session_id="+props.session.sessId;
			oper="save";
			let data={...inputValues};
			let tmp=inputValues.filter_months;
			tmp.indexOf(inputValues.month)===-1?tmp.push(inputValues.month):console.log("Already esistsing month.");
			setInputValues({...inputValues,filter_months:tmp,
											filter_years: inputValues.year,
			});
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="list_products") {
			let url="getMonthlyRequestProducts";
			url+="?session_id="+props.session.sessId;
			oper="list_products";
			let data={
				monthly_requests_id: elementData.id,
				center_id: elementData.center_id,
			};
			currentRequest=elementData;
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="add_product") {
			setProductsList(dataValues.productsList);
			setInputValuesProducts(defaultInputValuesProducts);
			setDialogValues({...dialogValues,openAddEditProduct: true,titleAddEditProduct: "Adaugare produs nou"});
			setInputError(defaultInputError);
			setAvailableQuantity("");
			setUnitaryPrice("");
			setDataValues({...dataValues,subAgreementsList:[]});							
		}
		if(what==="edit_product") {
			let tmp={...elementData};
			tmp.filter_products=inputValuesProducts.filter_products;
			tmp.filter_product_type=inputValuesProducts.filter_product_type;
			tmp.sub_agreements_id=0;
			setProductsList(dataValues.productsList.filter((product)=>((product.product_type_id===elementData.product_type_id)||(elementData.product_type_id==="")||(!elementData.product_type_id))));			
			setInputValuesProducts(tmp);
			setDialogValues({...dialogValues,openAddEditProduct: true,titleAddEditProduct: "Editare produs "});
			setInputError(defaultInputError);
			setAvailableQuantity("");
			setUnitaryPrice("");
			setDataValues({...dataValues,subAgreementsList:[]});							
		}
		if(what==="delete_product") {
			let url="deleteMonthlyRequestProduct";
			url+="?session_id="+props.session.sessId;
			oper="delete_product";
			let data={
				id: elementData.id,
				monthly_requests_id: currentRequest.id,
				center_id: elementData.center_id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save_product") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(!inputValuesProducts.product_id) {
				setMessageText("Eroare: Alegeti un produs din lista!");				
				document.getElementById("product_id").classList.add("required_input_error");
				return false;
			}
			if(!inputValuesProducts.product_mu_id) {
				setMessageText("Eroare: Alegeti o unitate de masura!");				
				document.getElementById("product_mu_id").classList.add("required_input_error");
				return false;
			}
			if(!inputValuesProducts.quantity_1) {
				setMessageText("Eroare: Completati cantitatile!");				
				document.getElementById("quantity_1").classList.add("required_input_error");
				return false;
			}
			if(!inputValuesProducts.quantity_2) {
				setMessageText("Eroare: Completati cantitatile!");				
				document.getElementById("quantity_2").classList.add("required_input_error");
				return false;
			}
			if(!inputValuesProducts.quantity_3) {
				setMessageText("Eroare: Completati cantitatile!");				
				document.getElementById("quantity_3").classList.add("required_input_error");
				return false;
			}			
			if(!inputValuesProducts.quantity_4) {
				setMessageText("Eroare: Completati cantitatile!");				
				document.getElementById("quantity_4").classList.add("required_input_error");
				return false;
			}
			let url="saveMonthlyRequestProduct";
			url+="?session_id="+props.session.sessId;
			oper="save_product";
			let data={...inputValuesProducts};
			data.monthly_requests_id=currentRequest.id;
			data.center_id=currentRequest.center_id;			
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save_template") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(inputValuesTemplates.name==="") {
				setMessageText("Eroare: Completati campul nume!");				
				document.getElementById("template_name").classList.add("required_input_error");
				return false;
			}
			let url="saveMonthlyTemplate";
			url+="?session_id="+props.session.sessId;
			oper="save_template";
			let data={...inputValuesTemplates};
			data.centers_requests_id=currentRequest.id;
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="apply_template") {
			setDialogValues({...dialogValues,openListTemplates: true,titleListTemplates: "Aplica sablon"});
		}
		if(what==="save_apply_template") {
			let url="applyMonthlyTemplateToMonthlyRequest";
			url+="?session_id="+props.session.sessId;
			oper="save_apply_template";
			let data={
				template_id: elementData.id,
				monthly_requests_id: currentRequest.id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save_quantities") {
			let url="saveQuantitiesMonthlyRequest";
			url+="?session_id="+props.session.sessId;
			oper="save_quantities";
			let data={
				quantities: tableQuantities,
			};
			console.log(data);
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="find_contract") {
			let url="findSubAgreementByProduct";
			url+="?session_id="+props.session.sessId;
			oper="find_contract";
			let data={
				product_id: inputValuesProducts.product_id,
				product_mu_id: inputValuesProducts.product_mu_id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
	}

	const success_handler = (result) => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
			setMessageText("");
		}
		if(result.ok===0) {
			setMessageText("Eroare: "+result.error);
			return false;
		}
		if(result.is_auth===0) {
			navigate("/login");			
			return false;
		}
		if(result.message) {
			setMessageText(result.message);			
		}
		if((oper==="get")||(oper==="save")||(oper==="delete")) {
			setDialogValues(defaultDialogValues);
			if(oper==="get") {
				setDataValues({...dataValues,centersRequestsList:(result.centersRequestsList?result.centersRequestsList:[]),
											productsList:(result.productsList?result.productsList:[]),
											MUsList:(result.MUsList?result.MUsList:[]),
											centersList:(result.centersList?result.centersList:[]),
											productsTypesList:(result.productsTypesList?result.productsTypesList:[]),
											typesList:(result.typesList?result.typesList:[]),
				});
			}else{
				setDataValues({...dataValues,centersRequestsList:(result.centersRequestsList?result.centersRequestsList:[])});				
			}
			setCentersRequestsList(result.centersRequestsList?result.centersRequestsList
																					.filter((request)=>((request.center_name.toLowerCase().indexOf(inputValues.filter_centers.toLowerCase())>-1)||(inputValues.filter_centers==="")))
																					.filter((request)=>((request.year===inputValues.filter_years)||(inputValues.filter_years==="")))
																					.filter((request)=>(inputValues.filter_months.includes(request.month)))
																					.filter((request)=>((request.type_id===inputValues.filter_types)||(inputValues.filter_types==="")||(!inputValues.filter_types)))
			:[]);
			setProductsList(result.productsList?result.productsList:[]);
            if(!dataOk) {
                setDataOk(true);
            }
			oper="";
		}
		if((oper==="list_products")||(oper==="save_product")||(oper==="delete_product")) {
			if(oper==="list_products") {
				setDataValues({...dataValues,requestProductsList:(result.requestProductsList?result.requestProductsList:[]),
											templatesList:(result.templatesList?result.templatesList:[])
				});							
				setTemplatesList(result.templatesList?result.templatesList:[]);
			}else{
				setDataValues({...dataValues,requestProductsList:(result.requestProductsList?result.requestProductsList:[])});											
			}
			setInputValuesProducts(defaultInputValuesProducts);
			setRequestProductsList(result.requestProductsList?result.requestProductsList
																					.filter((product)=>((product.product_name.toLowerCase().indexOf(inputValuesProducts.filter_products.toLowerCase())>-1))||(inputValuesProducts.filter_products===""))
																					.filter((product)=>((product.product_type_id===inputValuesProducts.filter_product_type)||(inputValuesProducts.filter_product_type==="")))
			:[]);
			let tmp=monthsList.filter((month)=>(month.value==currentRequest.month));
			setDialogValues({...dialogValues,openListProducts: true,titleListProducts: "Lista de produse pentru necesarul ["+currentRequest.center_name+" - luna "+tmp[0].label+"]",
											openAddEditProduct: false,titleAddEditProduct: ""
			});
			if(result.requestProductsList) {
				let tmp=[];
				result.requestProductsList.forEach(function(product) {
					let c_quantity = {
						id: product.id,
						quantity_1: product.quantity_1,
						quantity_2: product.quantity_2,
						quantity_3: product.quantity_3,
						quantity_4: product.quantity_4
					};
					tmp.push(c_quantity);
				});
				setTableQuantities(tmp);
			}
			oper="";
		}
		if(oper==="save_template") {
			setDataValues({...dataValues,templatesList:(result.templatesList?result.templatesList:[])});	
			oper="";
		}
		if(oper==="save_apply_template") {
			if(result.requestProductsList) {
				let tmp=[];
				result.requestProductsList.forEach(function(product) {
					let c_quantity = {
						id: product.id,
						quantity_1: product.quantity_1,
						quantity_2: product.quantity_2,
						quantity_3: product.quantity_3,
						quantity_4: product.quantity_4
					};
					tmp.push(c_quantity);
				});
				setTableQuantities(tmp);
			}
			setDataValues({...dataValues,requestProductsList:(result.requestProductsList?result.requestProductsList:[])});										
			setRequestProductsList(result.requestProductsList?result.requestProductsList:[]);													
			setDialogValues({...dialogValues,openListTemplates: false,titleListTemplates: ""});
			oper="";
		}
		if(oper==="find_contract") {
			setDataValues({...dataValues,subAgreementsList:(result.subAgreementsList?result.subAgreementsList:[])});							
			if(!result.subAgreementsList.length) {
				let tmp={
					disableSave: true,
					errorText: "Nu exista un contract asociat!",
				}
				setInputError(tmp);
			}else{
				if(result.subAgreementsList.length===1) {
					setInputValuesProducts({...inputValuesProducts,sub_agreements_id:result.subAgreementsList[0].sub_agreement_id,});							
					setAvailableQuantity(result.subAgreementsList[0].quantity);
					setUnitaryPrice(result.subAgreementsList[0].unitary_price);
				}
			}
			oper="";
		}
	}

	const fail_handler = () => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
		}
		setMessageText("Eroare de conexiune. Va rugam sa incercati mai tarziu!");
	}

	const wait_handler = () => {
		setBlockScreen(true);
		setMessageText("Operatiunea este in curs...");
	}

	useEffect(() => {
		if(props.session.sessId) {
			oper="get";
			let url="getMonthlyRequests";
			url+="?session_id="+props.session.sessId;
			let data={};
			fetch_url_post(url,data,success_handler,fail_handler);
		}else{
			navigate("/login");
		}
	},[props.session.sessId]);

	const addEditDialog = () => {
		return(
			<Dialog header={dialogValues.titleAddEdit} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})} className="responsive-dialog-med-small">
				<Grid container spacing={1} style={{"paddingTop":"12px","maxHeight":"72vh"}}>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="center_id">Centru*</label>
						<Dropdown name="center_id" id="center_id" style={{"width":"100%"}} filter options={dataValues.centersList} optionLabel="name" optionValue="id" value={inputValues.center_id} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={6} sm={6} md={5} lg={5} className="field padding-med">
						<label htmlFor="type_id">Tip*</label>
						<Dropdown name="type_id" id="type_id" style={{"width":"100%"}} options={dataValues.typesList} optionLabel="name" optionValue="id" value={inputValues.type_id} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={6} sm={6} md={2} lg={2} className="field padding-med">
						<label htmlFor="year">Anul*</label>
						<Dropdown name="year" id="year" style={{"width":"100%"}} options={yearsList} value={inputValues.year} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={6} sm={6} md={3} lg={3} className="field padding-med">
						<label htmlFor="month">Luna*</label>
						<Dropdown name="month" id="month" style={{"width":"100%"}} options={monthsList} value={inputValues.month} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={6} sm={6} md={2} lg={2} className="field padding-med">
						<label htmlFor="active">Activ</label>
						<Dropdown name="active" id="active" style={{"width":"100%"}} options={activeList} value={inputValues.active} onChange={(evt) => handleChange(evt)}/>
					</Grid>						
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="observations">Observatii</label>
						<InputTextarea name="observations" id="observations" style={{"width":"100%","height":"90px"}} rows={5} cols={30} value={inputValues.observations} onChange={(evt) => handleChange(evt)}/>							
					</Grid>						
					<Grid item xs={12} sm={12} md={12} lg={7} style={{"textAlign":"left","marginTop":"21px"}}>
						<div style={{"color":"#FF0000","fontWeight":"600","paddingTop":"0px"}}>
							{inputError.errorText}
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={5} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save")} disabled={inputError.disableSave}/>
						<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})}/>
					</Grid>
				</Grid>
			</Dialog>
		);
	}

	const listProductsDialog = () => {
		return(
			<Dialog header={dialogValues.titleListProducts} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openListProducts:false})} className="responsive-dialog-big">
				<div>
					<Grid container spacing={1} style={{}}>
						<Grid item xs={12} sm={12} md={4} lg={4} xl={4} className="field padding-med">
							<InputText name="filter_products" id="filter_products" style={{"width":"100%"}} value={inputValuesProducts.filter_products} placeholder="Cauta produs..." onChange={(evt) => handleChangeProducts(evt)}/>							
						</Grid>						
						<Grid item xs={12} sm={12} md={3} lg={3} xl={3} className="field padding-med">
							<Dropdown name="filter_product_type" id="filter_product_type" style={{"width":"100%"}} filter options={dataValues.productsTypesList} placeholder="Filtrare categorie..." showClear optionLabel="name" optionValue="id" value={inputValuesProducts.filter_product_type} onChange={(evt) => handleChangeProducts(evt)}/>
						</Grid>						
						<Grid item xs={12} sm={12} md={5} lg={5} xl={5} className="field padding-med text-right">
							<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"9px"}} onClick={(evt) => {handleButton(evt,"save_quantities")}}/>
							<Button label="Aplica sablon" icon="pi pi-copy" className="p-button-sm p-button-primary p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => {handleButton(evt,"apply_template")}} disabled={(requestProductsList.length>0?true:false)}/>
							<Button label="Adauga produs" icon="pi pi-plus-circle" className="p-button-sm p-button-primary p-button-raised" style={{}} onClick={(evt) => {handleButton(evt,"add_product")}}/>
						</Grid>						
					</Grid>
					<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
						<DataTable
							id="centers_requests_products"
							value={requestProductsList}
							scrollable
							scrollHeight="60vh"
							style={{"minHeight":"63vh"}}
							scrollDirection="both"
							stripedRows
							resizableColumns
							rowGroupMode="rowspan"
							groupRowsBy="product_type"
							sortMode="single"
							sortField="product_type"
							sortOrder={1}
							rowClassName={rowClassProducts}
							emptyMessage="Nu exista inregistrari"
						>
							<Column field="product_type" header="Tip produs" style={{"width":"17%","backgroundColor":"#FFFFFF"}} body={tableColTemplateProducts}></Column>
							<Column field="product_name" header="Produs" style={{"width":"30%"}}></Column>
							<Column field="product_mu_name" header="U.M." style={{"width":"120px"}}></Column>
							<Column field="quantity_1" header="S1" style={{"width":"80px","textAlign":"center"}} body={tableColTemplateProducts}></Column>
							<Column field="quantity_2" header="S2" style={{"width":"80px","textAlign":"center"}} body={tableColTemplateProducts}></Column>
							<Column field="quantity_3" header="S3" style={{"width":"80px","textAlign":"center"}} body={tableColTemplateProducts}></Column>
							<Column field="quantity_4" header="S4" style={{"width":"80px","textAlign":"center"}} body={tableColTemplateProducts}></Column>
							<Column field="yearly_totals" header="NA" style={{"overflow":"hidden","maxWidth":"24px","textOverflow":"ellipsis","textAlign":"center"}} body={tableColTemplateProducts}></Column>
							<Column field="yearly_totals_diff" header="NA-C" style={{"overflow":"hidden","maxWidth":"30px","textOverflow":"ellipsis","textAlign":"center"}} body={tableColTemplateProducts}></Column>
							<Column field="sub_agreements" header="CS" style={{"overflow":"hidden","maxWidth":"24px","textOverflow":"ellipsis","textAlign":"center"}} body={tableColTemplateProducts}></Column>
							<Column field="sub_agreements_diff" header="CS-C" style={{"overflow":"hidden","maxWidth":"30px","textOverflow":"ellipsis","textAlign":"center"}} body={tableColTemplateProducts}></Column>
							<Column field="buttons" header="" style={{"width":"195px"}} body={tableColTemplateProducts}></Column>
						</DataTable>
					</Box>
					<Box sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none", xl: "none" } }}>

					</Box>
				</div>
			</Dialog>
		);
	}

	const addEditProductDialog = () => {
		return(
			<Dialog header={dialogValues.titleAddEditProduct} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openAddEditProduct:false})} className="responsive-dialog-small">
				<Grid container spacing={1} style={{"paddingTop":"12px","maxHeight":"72vh"}}>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="product_type_id">Categorie*</label>
						<Dropdown name="product_type_id" id="product_type_id" style={{"width":"100%"}} filter options={dataValues.productsTypesList} showClear optionLabel="name" optionValue="id" value={inputValuesProducts.product_type_id} onChange={(evt) => handleChangeProducts(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="product_id">Produs* ({productsList.length} produse gasite)</label>
						<Dropdown name="product_id" id="product_id" style={{"width":"100%"}} filter options={productsList} showClear optionLabel="name" optionValue="id" value={inputValuesProducts.product_id} onChange={(evt) => handleChangeProducts(evt)} disabled={(inputValuesProducts.product_type_id?false:false)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={4} className="field padding-med">
						<label htmlFor="product_mu_id">Unitate de masura*</label>
						<Dropdown name="product_mu_id" id="product_mu_id" style={{"width":"100%"}} options={dataValues.MUsList} filter value={inputValuesProducts.product_mu_id} optionLabel="name" optionValue="id" onChange={(evt) => handleChangeProducts(evt)} disabled={inputValuesProducts.product_id?false:true}/>
					</Grid>
					<Grid item xs={12} sm={12} md={8} lg={8} className="field padding-med text-right">
						<Button label="Cauta contract subsecvent" icon="pi pi-list" className="p-button-sm p-button-raised" style={{"marginTop":"24px"}} onClick={(evt) => handleButton(evt,"find_contract")} disabled={inputValuesProducts.product_id?false:true}/>
					</Grid>
					<Grid item xs={12} sm={12} md={8} lg={8} className="field padding-med">
						<label htmlFor="">Contract subsecvent*</label>
						<Dropdown name="sub_agreements_id" id="sub_agreements_id" style={{"width":"100%"}} options={dataValues.subAgreementsList} optionLabel="sub_agreement" optionValue="sub_agreement_id" value={inputValuesProducts.sub_agreements_id} onChange={(evt) => handleChangeProducts(evt)} disabled={dataValues.subAgreementsList.length>0?false:true}/>
					</Grid>
					<Grid item xs={12} sm={12} md={2} lg={2} className="field padding-med">
						<label htmlFor="unitary_price">Pret unitar</label>
						<InputText name="unitary_price" id="unitary_price" pattern="[0-9.]*" style={{"width":"100%"}} value={unitaryPrice} disabled={dataValues.subAgreementsList.length>0?false:true}/>
					</Grid>
					<Grid item xs={12} sm={12} md={2} lg={2} className="field padding-med">
						<label htmlFor="available_quantity">Cantitate</label>
						<InputText name="available_quantity" id="available_quantity" pattern="[0-9.]*" style={{"width":"100%"}} value={availableQuantity} disabled={dataValues.subAgreementsList.length>0?false:true}/>
					</Grid>
					<Grid item xs={12} sm={12} md={3} lg={3} className="field padding-med">
						<label htmlFor="quantity_1">Cantitate 1*</label>
						<InputText name="quantity_1" id="quantity_1" pattern="[0-9.]*" style={{"width":"100%"}} value={inputValuesProducts.quantity_1} onChange={(evt) => handleChangeProducts(evt)} disabled={dataValues.subAgreementsList.length>0?false:true}/>
					</Grid>
					<Grid item xs={12} sm={12} md={3} lg={3} className="field padding-med">
						<label htmlFor="quantity_2">Cantitate 2*</label>
						<InputText name="quantity_2" id="quantity_2" pattern="[0-9.]*" style={{"width":"100%"}} value={inputValuesProducts.quantity_2} onChange={(evt) => handleChangeProducts(evt)} disabled={dataValues.subAgreementsList.length>0?false:true}/>
					</Grid>
					<Grid item xs={12} sm={12} md={3} lg={3} className="field padding-med">
						<label htmlFor="quantity_3">Cantitate 3*</label>
						<InputText name="quantity_3" id="quantity_3" pattern="[0-9.]*" style={{"width":"100%"}} value={inputValuesProducts.quantity_3} onChange={(evt) => handleChangeProducts(evt)} disabled={dataValues.subAgreementsList.length>0?false:true}/>
					</Grid>
					<Grid item xs={12} sm={12} md={3} lg={3} className="field padding-med">
						<label htmlFor="quantity_4">Cantitate 4*</label>
						<InputText name="quantity_4" id="quantity_4" pattern="[0-9.]*" style={{"width":"100%"}} value={inputValuesProducts.quantity_4} onChange={(evt) => handleChangeProducts(evt)} disabled={dataValues.subAgreementsList.length>0?false:true}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="observations">Observatii</label>
						<InputTextarea name="observations" id="observations" style={{"width":"100%","height":"90px"}} rows={5} cols={30} value={inputValuesProducts.observations} onChange={(evt) => handleChangeProducts(evt)}/>							
					</Grid>						
					<Grid item xs={12} sm={12} md={12} lg={7} style={{"textAlign":"left","marginTop":"21px"}}>
						<div style={{"color":"#FF0000","fontWeight":"600","paddingTop":"0px"}}>
							{inputError.errorText}
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={5} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save_product")} disabled={((inputError.disableSave)||(!inputValuesProducts.sub_agreements_id))}/>
						<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openAddEditProduct:false})}/>
					</Grid>
				</Grid>
			</Dialog>
		);
	}

	const listTemplatesDialog = () => {
		return(
			<Dialog header={dialogValues.titleListTemplates} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openListTemplates:false})} className="responsive-dialog-med">
				<div>
					<Grid container spacing={1} style={{}}>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6} className="field padding-med">
							<InputText name="filter_templates" id="filter_templates" style={{"width":"100%"}} value={inputValuesTemplates.filter_templates} placeholder="Cauta sablon..." onChange={(evt) => handleChangeTemplates(evt)}/>							
						</Grid>						
					</Grid>
					<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
						<DataTable
							id="centers_requests_products"
							value={templatesList}
							scrollable
							scrollHeight="45vh"
							style={{"minHeight":"45vh"}}
							scrollDirection="both"
							stripedRows
							resizableColumns
							emptyMessage="Nu exista inregistrari"
						>
							<Column field="name" header="Nume sablon" style={{"width":"35%"}} sortable></Column>
							<Column field="observations" header="Observatii" style={{"width":"60%"}}></Column>
							<Column field="buttons" header="" style={{"width":"100px"}} body={tableColTemplateTemplate}></Column>
						</DataTable>
					</Box>
					<Box sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none", xl: "none" } }}>

					</Box>
				</div>
			</Dialog>
		);
	}

	const tableColTemplate = (row_data,column) => {
		if(column.field==="buttons") {
			return(
				<span>
					<Button label="Editare" icon="pi pi-pencil" tooltip="Editeaza necesar" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"edit",row_data)}/>
					<Button label="Produse" icon="pi pi-list" tooltip="Lista de produse" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"list_products",row_data)}/>
					<Button label="Stergere" icon="pi pi-trash" tooltip="Sterge necesar" className="p-button-sm p-button-raised p-button-danger" onClick={(evt) => confirm(evt,"delete",row_data)}/>
				</span>
			);
		}
		if(column.field==="active") {
			if(row_data.active===1) {
				return(
					<span>
						<Tag severity="success" style={{"marginLeft":"12px"}} value="ACTIV"></Tag>
					</span>
				)
			}else{
				return(
					<span>
						<Tag severity="danger" style={{"marginLeft":"12px"}} value="INACTIV"></Tag>
					</span>
				)
			}
		}
		if(column.field==="month") {
			let tmp=monthsList.filter((month)=>(month.value==row_data.month));
			return(
				<span>
					{tmp[0].label}
				</span>
			);
		}
	}

	const tableColTemplateProducts = (row_data,column) => {
		if(column.field==="buttons") {
			return(
				<span>
					<Button label="Editare" icon="pi pi-pencil" tooltip="Editeaza produs" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"edit_product",row_data)}/>
					<Button label="Stergere" icon="pi pi-trash" tooltip="Sterge produs" className="p-button-sm p-button-raised p-button-danger" onClick={(evt) => confirm(evt,"delete_product",row_data)}/>
				</span>
			);
		}
		if(column.field==="product_type") {
			return(
				<div className="flex align-items-center gap-2">
					<span className="font-bold">{row_data.product_type}</span>
				</div>
			);
		}		
		if(column.field==="quantity_1") {
			return <InputText name="quantity_1" id={row_data.id} className="p-inputtext_table" value={tableQuantities[tableQuantities.findIndex((product)=>(product.id===row_data.id))].quantity_1} pattern="[0-9.]*" onChange={(evt) => handleChangeTable(evt,row_data.id,1)} onKeyDown={(evt) => handleFocusTable(evt)} disabled={(row_data.sub_agreements_id===0?true:false)} />;			
		}
		if(column.field==="quantity_2") {
			return <InputText name="quantity_2" id={row_data.id} className="p-inputtext_table" value={tableQuantities[tableQuantities.findIndex((product)=>(product.id===row_data.id))].quantity_2} pattern="[0-9.]*" onChange={(evt) => handleChangeTable(evt,row_data.id,2)} onKeyDown={(evt) => handleFocusTable(evt)} disabled={(row_data.sub_agreements_id===0?true:false)} />;			
		}
		if(column.field==="quantity_3") {
			return <InputText name="quantity_3" id={row_data.id} className="p-inputtext_table" value={tableQuantities[tableQuantities.findIndex((product)=>(product.id===row_data.id))].quantity_3} pattern="[0-9.]*" onChange={(evt) => handleChangeTable(evt,row_data.id,3)} onKeyDown={(evt) => handleFocusTable(evt)} disabled={(row_data.sub_agreements_id===0?true:false)} />;			
		}
		if(column.field==="quantity_4") {
			return <InputText name="quantity_4" id={row_data.id} className="p-inputtext_table" value={tableQuantities[tableQuantities.findIndex((product)=>(product.id===row_data.id))].quantity_4} pattern="[0-9.]*" onChange={(evt) => handleChangeTable(evt,row_data.id,4)} onKeyDown={(evt) => handleFocusTable(evt)} disabled={(row_data.sub_agreements_id===0?true:false)} />;			
		}
		if(column.field==="yearly_totals") {
			return(
				<span>
					{(row_data.yearly_totals?row_data.yearly_totals:"-")}
				</span>
			);
		}
		if(column.field==="yearly_totals_diff") {
			if((row_data.yearly_totals)&&(row_data.orders_totals_per_center)) {
				return(
					<span>
						{(row_data.yearly_totals-row_data.orders_totals_per_center>0?row_data.yearly_totals-row_data.orders_totals_per_center:"0")}
					</span>
				);
			}else{
				return(
					<span>
						-
					</span>
				)
			}
		}
		if(column.field==="sub_agreements") {
			return(
				<span>
					{(row_data.sub_agreements_totals?row_data.sub_agreements_totals:"-")}
				</span>
			);
		}
		if(column.field==="sub_agreements_diff") {
			if((row_data.sub_agreements_totals)&&(row_data.orders_totals)) {
				return(
					<span>
						{row_data.sub_agreements_totals-row_data.orders_totals}
					</span>
				);
			}else{
				return(
					<span>
						-
					</span>
				)
			}
		}
	}

	const tableColTemplateTemplate = (row_data,column) => {
		if(column.field==="buttons") {
			return(
				<span>
					<Button label="Aplica" icon="pi pi-check-circle" tooltip="Editeaza necesar" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"save_apply_template",row_data)}/>
				</span>
			);
		}
	}

    const rowClassProducts = (data) => {
		return {
            "no_contract": data.sub_agreements_id === 0
        };
    };

	const confirm = (evt,what,elementData) => {
		if((what==="delete")||(what==="delete_product")) {
			confirmDialog({
				message: "Sigur doriti stergerea?",
				header: "Confirmare stergere",
				icon: "pi pi-exclamation-triangle",
				accept: () => handleButton(evt,what,elementData),
				reject: () => null,
			});
		}
	}

	if(dataOk) {
		return(
			<BlockUI blocked={blockScreen} fullScreen>
				<div>
					<Grid container spacing={1} style={{}}>
						<Grid item xs={12} sm={6} md={8} lg={8} xl={8} className="field padding-med">
							<InputText name="filter_centers" id="filter_centers" style={{"width":"40%","float":"left"}} value={inputValues.filter_centers} placeholder="Cauta centru..." onChange={(evt) => handleChange(evt)}/>							
							<Dropdown name="filter_years" id="filter_years" style={{"width":"13%","marginLeft":"6px"}} options={yearsList} value={inputValues.filter_years} onChange={(evt) => handleChange(evt)}/>	
							<MultiSelect name="filter_months" id="filter_months" style={{"width":"18%","marginLeft":"6px","height":"38px","lineHeight":"0.8"}} options={monthsList} value={inputValues.filter_months} optionLabel="label" optionValue="value" onChange={(evt) => handleChange(evt)}/>	
							<Dropdown name="filter_types" id="filter_types" style={{"width":"26%","marginLeft":"6px"}} options={dataValues.typesList} optionLabel="name" optionValue="id" showClear value={inputValues.filter_types} onChange={(evt) => handleChange(evt)}/>	
						</Grid>						
						<Grid item xs={12} sm={3} md={2} lg={2} xl={2} className="field padding-med text-left">
							<h6 style={{"marginTop":"9px","color":"#000000"}}>{centersRequestsList.length} {(((centersRequestsList.length>1)||(centersRequestsList.length===0))?" inregistrari gasite.":" inregistrare gasita.")}</h6>
						</Grid>						
						<Grid item xs={12} sm={3} md={2} lg={2} xl={2} className="field padding-med text-right">
							<Button label="Adauga necesar nou" icon="pi pi-plus-circle" className="p-button-sm p-button-primary p-button-raised" style={{}} onClick={(evt) => {handleButton(evt,"add")}}/>
						</Grid>						
					</Grid>
					<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
						<div className="card">
							<DataTable
								value={centersRequestsList}
								scrollable
								scrollHeight="60vh"
								style={{"minHeight":"63vh"}}
								scrollDirection="both"
								stripedRows
								resizableColumns
								columnResizeMode="fit"
								responsiveLayout="stack"
								emptyMessage="Nu exista inregistrari"
							>
								<Column field="center_name" header="Nume centru" style={{"flexGrow":"1","flexBasis":"150px"}} sortable></Column>
								<Column field="year" header="Anul" style={{"flexGrow":"0","flexBasis":"75px","textAlign":"center"}} sortable></Column>
								<Column field="month" header="Luna" style={{"flexGrow":"0","flexBasis":"180px"}} body={tableColTemplate} sortable></Column>
								<Column field="type_name" header="Tip necesar" style={{"flexGrow":"0","flexBasis":"240px"}} sortable></Column>
								<Column field="active" header="Stare" style={{"flexGrow":"0","flexBasis":"90px"}} body={tableColTemplate} sortable></Column>
								<Column field="reg_date_parsed" header="Data introducerii" style={{"flexGrow":"0","flexBasis":"180px"}} sortable></Column>
								<Column field="buttons" header="" style={{"flexGrow":"0","flexBasis":"285px"}} body={tableColTemplate}></Column>
							</DataTable>
						</div>
					</Box>
					<Box sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none", xl: "none" } }}>

					</Box>
				</div>
				<ConfirmDialog />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
				{dialogValues.openAddEdit && addEditDialog()}
				{dialogValues.openAddEditProduct && addEditProductDialog()}
				{dialogValues.openListProducts && listProductsDialog()}
				{dialogValues.openListTemplates && listTemplatesDialog()}
            </BlockUI>
		);
	}else{
		return(
			<React.Fragment>
				<LinearProgress />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
			</React.Fragment>
		);		
	}
};

export default MonthlyRequests;


